import { ConfirmationDialog, Module } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { LoadingIndicator } from "../../../assets/vfx/loadingIndicator/vfxLoadingIndicator";
import DisplayData from "../../common/DisplayData/DisplayData";
import { LookupGroupService } from "../lookupgroup/lookupGroupService";
import { ViewProps } from "../props";
import { LookupVIewDto } from "../../../assets/utils/lib/lookupDto";

interface LookupValueViewProps<T> {
    data: T | undefined;
    show: boolean;
    lookupCategoryLookupValues?: DropdownOption[] | undefined;
    moduleType: Module;
    onHide: () => void;
    onEdit: () => void;
    onDelete: () => void;
    isLoading: boolean;
}

export const LookupValueView = <T extends ViewProps.ValueTypeDto,>(props: LookupValueViewProps<T>) => {
    const typeDto: LookupVIewDto | undefined = props?.data as LookupVIewDto;
    const canEdit = props.isLoading || !(props.moduleType === Module.PopHub && typeDto?.isLocked);
    const canDelete = props.isLoading || !(props.moduleType === Module.PopHub && typeDto?.isLocked);
    return (
        <Drawer.View
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={() => props.onHide()}
            onEdit={canEdit ? props.onEdit : undefined}
            title="View Lookup Category"
            onDelete={canDelete ? props.onDelete : undefined}
            modalDialogProps={canDelete ? new ConfirmationDialog().get(props.onDelete, "Delete", { "Name": typeDto?.name ?? Constants.emptyString }) : undefined}
        >
            {props.isLoading ? (
                <LoadingIndicator isFullPage={true} />
            ) : (
                <>
                    <DisplayData text="Name" importedData={typeDto?.name ?? Constants.emptyString} />
                    <DisplayData text="Description" importedData={typeDto?.description ?? Constants.emptyString} />
                    {(() => {
                        if (typeDto?.typeId != undefined && typeDto?.typeId != null && typeDto?.typeId != Constants.emptyGuid) {
                            const category: DropdownOption | undefined = props.lookupCategoryLookupValues?.find(x => x.value === typeDto?.typeId);
                            if (category) {
                                return <DisplayData text="Category" importedData={category.display} />
                            }
                        }

                        if (typeDto?.groupId !== undefined && typeDto?.groupId !== null && typeDto?.groupId !== Constants.emptyGuid) {
                            const service: LookupGroupService<ViewProps.GroupTypeDto> = new LookupGroupService<ViewProps.GroupTypeDto>(props.moduleType);
                            const { data: group } = service.getLookupGroupQuery(typeDto?.groupId);
                            if (group !== undefined && group !== null) {
                                return <DisplayData text="Group" importedData={group.name} />
                            }
                        }
                    })()}
                </>
            )}
        </Drawer.View>
    );
}